import { useEffect } from 'react';
import { Canvas } from 'fabric';

import { Tool, PencilProps } from '../draw-canvas.constants';
import { ToolBarTool } from './toolbar.style';
import IconPaintBrush from 'approot/shared/inline-svg/activity-builder/icon-paint-brush';
import { useDrawCanvasContext } from '../draw-canvas.context';
import ToolbarItem from './toolbar-item';

type Props = {
  canvas?: Canvas | null;
  pencilTool: PencilProps;
};

const ToolbarItemPencil = ({ pencilTool, canvas }: Props) => {
  const { toolSet, setPencilDrawing } = useDrawCanvasContext();

  useEffect(() => {
    if (canvas && toolSet?.tool === Tool.Pencil) {
      setPencilDrawing(canvas, pencilTool);
    }
  }, [pencilTool, canvas, toolSet?.tool, setPencilDrawing]);

  return (
    <ToolbarItem hoverText="Draw">
      <ToolBarTool
        data-selector="toolbar-pencil"
        $isActive={toolSet?.tool === Tool.Pencil}
        onClick={() => {
          if (canvas) {
            canvas.discardActiveObject();
            canvas.renderAll();
            setPencilDrawing(canvas, pencilTool);
          }
        }}
      >
        <IconPaintBrush width={24} height={24} />
      </ToolBarTool>
    </ToolbarItem>
  );
};

export default ToolbarItemPencil;
